import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar"; // Adjust the path as needed
import adminPC from "../assets/adminPC.png";
import adminXB from "../assets/adminXB.png";
import adminPS from "../assets/adminPS.png";
import api from "../utils/api";
import { FaTrash, FaToggleOn, FaToggleOff } from "react-icons/fa";
import { BiWorld } from "react-icons/bi";
import { useAuth } from "../context/AuthContext";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";


const ActivePromoCodes = () => {
  const [promoCodes, setPromoCodes] = useState([]);
  const [error, setError] = useState(null);
  const { token } = useAuth();

  useEffect(() => {
    const fetchCoupons = async () => {
      try {
        const response = await api.get('/coupons', {
          headers: { Authorization: `Bearer ${token}` },
        });
        setPromoCodes(response.data);
        // toast.success("Coupons fetched successfully!");
      } catch (err) {
        console.error(err);
        setError('Failed to fetch coupons.');
        toast.error("Failed to fetch coupons.");

      }
    };
    fetchCoupons();
  }, [token]);

  const handleDelete = async (couponId) => {
    if (window.confirm('Are you sure you want to delete this coupon?')) {
      try {
        await api.delete(`/coupons/${couponId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setPromoCodes((prevCoupons) => prevCoupons.filter((coupon) => coupon._id !== couponId));
        toast.success("Coupon deleted successfully!");

      } catch (err) {
        console.error(err);
        setError('Failed to delete coupon.');
        toast.error("Failed to delete coupon.");

      }
    }
  };

  const handleStatusToggle = async (couponId, currentStatus) => {
    const newStatus = currentStatus === 'active' ? 'inactive' : 'active';

    try {
      await api.put(`/coupons/${couponId}`, { status: newStatus }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPromoCodes((prevCoupons) =>
        prevCoupons.map((coupon) =>
          coupon._id === couponId ? { ...coupon, status: newStatus } : coupon
        )
      );
      toast.success(`Coupon status updated to ${newStatus}!`);

    } catch (error) {
      console.error('Failed to update coupon status:', error);
      setError('Failed to update status.');
      toast.error("Failed to update coupon status.");

    }
  };

  return (
    <div className="flex flex-col md:flex-row">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div className="flex-1 bg-gray-50 p-8">
        <h1 className="text-2xl font-bold text-gray-700 mb-6">Active Codes</h1>
        <ToastContainer />


        {error ? (
          <p className="text-red-500">{error}</p>
        ) : (
          <div className="bg-white p-6 rounded-lg shadow-md w-full">
            <div className="grid grid-cols-1 md:hidden gap-4">
              {promoCodes.map((code, index) => (
                <div key={index} className="border rounded-lg shadow-md p-4 flex flex-col">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <input type="checkbox" className="mr-2" />
                      <span className="bg-purple-500 text-white px-2 py-1 rounded-md font-bold">{code.couponCode}</span>
                    </div>
                    <span className="text-black font-medium">DISC: {code.discountPercentage}%</span>
                  </div>

                  <div className="mt-2 text-gray-500">Limit: {code.limit === 1000 ? "Unlimited" : code.limit}</div>

                  <div className="mt-2 flex items-center space-x-2">
                    {code.type === "XB" && <img src={adminXB} alt="Xbox" className="w-6 h-6" />}
                    {code.type === "PS" && <img src={adminPS} alt="PS" className="w-6 h-6" />}
                    {code.type === "PC" && <img src={adminPC} alt="PC" className="w-6 h-6" />}
                    {code.type === "all" && <BiWorld className="w-6 h-6" />}
                  </div>

                  <div className="mt-2 flex items-center justify-between">
                    <span
                      className={`px-3 py-1 rounded-full text-sm font-medium capitalize ${code.status === "active"
                        ? "bg-green-500 text-white"
                        : "bg-red-500 text-white"
                        }`}
                    >
                      {code.status}
                    </span>

                    <div className="flex space-x-2">
                      <button
                        className="p-2 bg-black text-white rounded-lg hover:bg-gray-800"
                        onClick={() => handleDelete(code._id)}
                      >
                        <FaTrash />
                      </button>
                      <button
                        className="p-2 bg-gray-300 text-black rounded-lg hover:bg-gray-400"
                        onClick={() => handleStatusToggle(code._id, code.status)}
                      >
                        {code.status === "active" ? <FaToggleOn /> : <FaToggleOff />}
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Desktop Table */}
            <table className="w-full border-collapse hidden md:table">
              <thead className="bg-gray-200">
                <tr>
                  <th className="px-4 py-2 text-left text-gray-700">NAME</th>
                  <th className="px-4 py-2 text-left text-gray-700">DISCOUNT(%)</th>
                  <th className="px-4 py-2 text-left text-gray-700">CONSOLE</th>
                  <th className="px-4 py-2 text-left text-gray-700">USAGE LIMIT</th>
                  <th className="px-4 py-2 text-left text-gray-700">STATUS</th>
                  <th className="px-4 py-2 text-left text-gray-700">ACTION</th>
                </tr>
              </thead>
              <tbody>
                {promoCodes.map((code, index) => (
                  <tr key={index} className="border-b">
                    <td className="px-4 py-2 text-gray-700">{code.couponCode}</td>
                    <td className="px-4 py-2 text-gray-700">{code.discountPercentage}</td>
                    <td className="px-4 py-2 text-gray-700">
                      {code.type === "XB" && <img src={adminXB} alt="Xbox" className="w-6 h-6 inline" />}
                      {code.type === "PS" && <img src={adminPS} alt="PS" className="w-6 h-6 inline" />}
                      {code.type === "PC" && <img src={adminPC} alt="PC" className="w-6 h-6 inline" />}
                      {code.type === "all" && <BiWorld className="w-6 h-6 inline" />}
                    </td>
                    <td className="px-4 py-2 text-gray-700">{code.limit === 1000000 ? "Unlimited" : code.limit}</td>
                    <td className="px-4 py-2">
                      <span
                        className={`px-3 py-1 rounded-full text-sm font-medium ${code.status === "active"
                          ? "bg-blue-200 text-blue-700"
                          : "bg-red-200 text-red-700"
                          }`}
                      >
                        {code.status}
                      </span>
                    </td>
                    <td className="px-4 py-2 flex space-x-2">
                      <button
                        className="px-4 py-2 bg-black text-white rounded-lg hover:bg-gray-800"
                        onClick={() => handleDelete(code._id)}
                      >
                        <FaTrash />
                      </button>
                      <button
                        className="px-4 py-2 bg-gray-300 text-black rounded-lg hover:bg-gray-400"
                        onClick={() => handleStatusToggle(code._id, code.status)}
                      >
                        {code.status === "active" ? <FaToggleOn /> : <FaToggleOff />
                        }
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="mt-4 text-sm text-gray-600">
              Showing 1-{promoCodes.length} of {promoCodes.length}
            </div>
          </div>
        )}

        <div className="flex justify-end mt-4">
          <Link to='/admin/promo-codes'
            className="px-6 py-3 bg-primary text-black rounded-lg hover:bg-yellow-300"
          >
            Back
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ActivePromoCodes;
